import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { RootState } from "src/store/store";

import { setStepStatusArray } from "src/reducers/slices/stepTrackerSlice";
import { setActiveAchEnrollmentStep } from "src/reducers/slices/AchEnrollmentStepsSlice";

import {
  ACH_DYNAMIC_COMPONENTS,
  STEP_TRACKER_DEFAULT_STATUS,
} from "src/constants/achEnrollment";

const useAchIntroductionViewModel = () => {
  const dispatch = useDispatch();

  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [additionalElement, setAdditionalElement] = useState<string>("");

  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const [isSpecialCharError, setSpecialCharError] = useState<boolean>(false);

  // prettier-ignore
  const [disableOtherUserInput, setDisableOtherUserInput] = useState<boolean>(true);

  const ACHData = useSelector(
    (state: RootState) => state.getSecData.value?.secDataDetails
  );

  useEffect(() => {
    window.scrollTo(0, 0);

    dispatch(setStepStatusArray(STEP_TRACKER_DEFAULT_STATUS));
    dispatch(setActiveAchEnrollmentStep(ACH_DYNAMIC_COMPONENTS.Authentication));
  }, []);

  return {
    selectedOptions,
    setSelectedOptions,

    additionalElement,
    setAdditionalElement,

    isSubmitted,
    setIsSubmitted,

    isError,
    setIsError,

    isSpecialCharError,
    setSpecialCharError,

    ACHData,

    disableOtherUserInput,
    setDisableOtherUserInput,
  };
};

export default useAchIntroductionViewModel;
